import { EInfrastructureType } from '../../types/offer';
import { IOfferDesktop } from '../../repositories/offers-comparison/entities/offer/OfferDesktop';

export function transformComparisonNewbuilding({ newbuilding }: IOfferDesktop) {
  if (!newbuilding) {
    return null;
  }

  return {
    ...newbuilding,
    infrastructure: newbuilding.infrastructure?.map(infrastructure => ({
      ...infrastructure,
      type: infrastructure.type as unknown as EInfrastructureType,
    })),
  };
}
